import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  template: `
    @if (showToolbar) {
      <app-toolbar></app-toolbar>
    }
    <div class="not-found-container ">
      <p class="four-o-four">404</p>
      <h1>Page not found</h1>
      <p>We can't seem to find the page you're looking for.</p>
      <p></p>
    </div>
  `,
  styles: [
    `
      .not-found-container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 70vh;
        width: 100%;
      }
      .four-o-four {
        font-size: 200px;
        margin: 0;
      }
    `
  ],
  standalone: false
})
export class PageNotFoundComponent implements OnInit {
  showToolbar: boolean;
  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.showToolbar = this.activatedRoute.snapshot.data?.showToolbar;
  }
}
